<template>
  <v-autocomplete
    v-model="selected"
    :label="label"
    :menu-props="{closeOnContentClick:true}"
    prepend-inner-icon="mdi-magnify"
    :search-input.sync="search"
    :clearable="clearable"
    :items="items"
    item-text="name"
    item-value="_id"
    return-object
    hide-details
    hide-no-data
    :rules="rule"
    :autofocus="autofocus"
    :outlined="outlined"
    :dense="dense"
    @click:clear="clear"
  >
    <template #item="{ item }">
      <v-list-item @click="emitLabo(item)">
        <v-list-item-action>
          <v-icon>mdi-pill</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{ item.name }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </template>
  </v-autocomplete>
</template>
<script>
import { laboAPI } from '@/services';
import i18n from '@/translations/i18n';

export default {
  props: {
    labo: { type: [Object, String, undefined] },
    label: { type: String, default: i18n.t('labosearch.search') },
    id: { type: String, default: undefined },
    clearable: { type: Boolean },
    autofocus: { type: Boolean },
    outlined: { type: Boolean },
    required: { type: Boolean },
    dense: { type: Boolean },
  },
  data: () => ({
    loading: false,
    entries: [],
    search: null,
    selected: null,
  }),
  computed: {
    items() {
      if (this.selected && this.selected._id && !this.entries.length) {
        return [this.selected];
      }
      return this.entries;
    },
    rule() {
      return [(value) => (this.required ? !!value || i18n.t('labosearch.req') : true)];
    },
  },
  watch: {
    search(val) { if (val && val !== this.selected) this.querySelections(val); },
    labo() { if (this.labo) this.selected = this.labo; },
    $route: {
      immediate: true,
      deep: true,
      handler() {
        if (this.id && !this.entries.length) {
          this.getLaboById();
        }
        if (!this.id && !this.labo) {
          this.selected = {};
          this.entries = [];
        }
      },
    },
  },
  mounted() { if (this.labo) this.selected = this.labo; },
  methods: {
    async querySelections(v) {
      this.loading = true;
      try {
        const { data } = await laboAPI.searchLabo(v, { limit: 5 });
        this.entries = data;
      } catch (err) {
        console.log(err);
      } finally {
        this.loading = false;
      }
    },
    async getLaboById() {
      this.loading = true;
      try {
        const { data } = await laboAPI.getLabo(this.id);
        this.selected = data;
      } catch (err) {
        console.error(err);
      } finally {
        this.loading = false;
      }
    },
    clear() {
      this.selected = {};
      this.$emit('emit-labo', undefined);
    },
    emitLabo(item) {
      this.$emit('emit-labo', item);
      this.selected = item;
    },
  },
};
</script>
